export default __webpack_public_path__ + "static/media/sqlite.5c36e2a1.svg";